<template>
  <div v-if="isApiResponse" class="c-bg--gray--pc c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />
        <div class="p-the-page-h12">
          <div class="p-the-page-h12__header">
            <CommonHeading> 有効期限切れのポイント </CommonHeading>
            <a v-touch:tap :href="link" class="p-the-page-h12__header__link">
              <span class="p-the-page-h12__header__link__text">
                ポイント有効期限一覧はこちら
              </span>
            </a>
          </div>
          <div v-if="expirationCnt == 0" class="p-the-page-h12__body">
            <p>有効期限切れのポイントはありません。</p>
          </div>
          <div v-if="expirationCnt != 0" class="p-the-page-h12__body">
            <ul class="p-the-page-h12__list">
              <li
                v-for="({
                  expiry_date,
                  transaction_details,
                  points,
                  transaction_type,
                  history_id
                },
                key) in expirationData"
                :key="key"
                class="p-the-page-h12__list__item"
                @click="expiredDetails(history_id)"
              >
                <ExpirationItemPanel
                  v-if="transaction_type === 50"
                  :date="expiry_date"
                  :detail="detail(transaction_details)"
                  :point="points"
                  :status="'受贈'"
                />
                <ExpirationItemPanel
                  v-else
                  :date="expiry_date"
                  :detail="detail(transaction_details)"
                  :point="points"
                  :status="'付与'"
                  :label="getLabel(transaction_details)"
                />
              </li>
            </ul>
          </div>
          <div class="p-the-page-h12__footer">
            <PageNavi
              v-if="pageNavi.maxPage > 1"
              :current-page="pageNavi.currentPage"
              :next-page-url="pageNavi.nextPageUrl"
              :prev-page-url="pageNavi.prevPageUrl"
              :max-page="pageNavi.maxPage"
              :base-url="pageNavi.baseUrl"
            />
          </div>
        </div>
      </div>
    </div>
    <FloatingGivePointButton />
    <TheFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import ExpirationItemPanel from "@/general/components/pages/parts/ExpiringPoints/expirationItemPanel.vue";
import commons from "@/common/store/modules/commons";
import { getExpirePointHistoryList } from "@/general/store/api";
import globals from "@/general/store/modules/globals";
import CONST_DATA from "@/general/mixins/const/constData";
import { getThanksOrGrantTypeLabel } from "@/common/assets/js/utils/types";
import AuthStorage from "@/general/utils/auth";

@Options({
  name: "ExpiredPoints",
  components: {
    ExpirationItemPanel
  }
})
export default class ExpiredPoints extends Vue {
  expirationData: any = [];
  //　初期表示の際、これを参照しているのでデータが有無かかわらず、メッセージが表示しているため、１をデフォルトで設定、
  // 実際の処理はサーバーから取得したデータで判断する。
  expirationCnt = 1;
  breadcrumb = [
    {
      text: "",
      url: CONST_DATA.SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "ポイント確認",
      url: CONST_DATA.SITE_MAP.POINT_CONFIRMATION,

      pageType: "lower"
    },
    {
      text: "有効期限切れのポイント",
      url: "",
      pageType: "lower"
    }
  ];

  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: ""
  };

  currentPage!: number;
  expiryPage = "expired";
  searchPage!: string;

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }

  detail(transaction_details: any) {
    if (transaction_details.grant_criteria) {
      return transaction_details.title;
    } else if (transaction_details.from_user) {
      return transaction_details.title;
    }
    return "";
  }

  getLabel(transactionDetails: any) {
    const { grant_type } = transactionDetails;
    return getThanksOrGrantTypeLabel(grant_type);
  }

  params = {
    expiry_point_type: "expired",
    page: 1,
    search: "",
    transaction_direction: "gaining"
  };

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const pageParam = urlParams.get("page");
    const expiryParam = urlParams.get("expiry_point_type")
      ? (urlParams.get("expiry_point_type") as string)
      : "";
    const searchParam = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";

    this.currentPage = pageParam ? parseInt(pageParam) : 1;

    this.expiryPage = expiryParam ? expiryParam : "expired";
    this.searchPage = searchParam ? searchParam : "";

    const response: any = await getExpirePointHistoryList(
      this.expiryPage,
      this.currentPage,
      this.pageSize,
      this.searchPage
    )
      .then((res) => {
        return res;
      })
      .catch(() => {
        window.location.href = CONST_DATA.SITE_MAP.POINT_CONFIRMATION;
        return;
      });

    const prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      const prevPage = 1;
    }
    const nextPage = this.currentPage + 1;
    const count = response.count as number;

    const maxPage =
      count % this.pageSize >= 1
        ? Math.floor(count / this.pageSize) + 1
        : count / this.pageSize;

    this.expirationData = response.results || [];
    // this.conditionsList = [];
    this.expirationCnt = response.count as number;

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.baseUrl = `${CONST_DATA.SITE_MAP.EXPIRED_POINTS}?`;

    await commons.getBreadcrumb(this.breadcrumb);

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.baseUrl =
      `${CONST_DATA.SITE_MAP.EXPIRED_POINTS}?` +
      "&search=" +
      this.searchPage +
      "&";

    this.pageNavi.nextPageUrl = this.pageNavi.baseUrl + "page=" + nextPage;

    this.pageNavi.prevPageUrl = this.pageNavi.baseUrl + "page=" + prevPage;
  }

  get link() {
    return `${CONST_DATA.SITE_MAP.EXPIRING_POINTS}`;
  }

  get expirationList() {
    return this.expirationData[0]?.expiration_list;
  }

  get isApiResponse() {
    return true;
    // return this.expirationData[0] != null;
  }

  get expiry_date() {
    return this.expirationData[0]?.expiry_date;
  }

  expiredDetails(id: NumberConstructor) {
    window.location.href = `${CONST_DATA.SITE_MAP.EXPIRED_POINT_DETAILS}?id=${id}`;
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-h12 {
  @include pc {
    max-width: rem(1110);
    margin: 0 auto;
    padding: rem(32) 0 rem(56);
  }
  @include sp {
    padding: rem(32) 0 0;
  }

  &__header {
    @include pc {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    ::v-deep(.c-common-heading1) {
      @include sp {
        font-size: rem(20);
      }
    }
    &__link {
      @include sp {
        margin-top: rem(24);
      }
      color: $common-primary;
      display: block;

      &.tap {
        color: $common-primary;
        text-decoration: underline;
      }

      &__text {
        font-weight: bold;
        font-size: rem(14);
      }
    }
  }

  &__body {
    @include pc {
      margin-top: rem(16);
      padding: rem(16) rem(8);
    }
    @include sp {
      padding: rem(24) 0 rem(48);
    }
    background-color: $common-white;
    border-radius: rem(4);
  }

  &__list {
    &__item {
      cursor: pointer;
      @include pc {
        border-bottom: px(1) solid $common-gray300;
      }
      @include sp {
        border: px(1) solid $common-gray300;
        border-radius: rem(4);
        padding: 0 rem(12);
        margin-bottom: rem(8);
      }
    }
  }
  &__footer {
    margin: rem(24) 0 0;
  }
}
</style>
